/**
 * Componente: PurchaseStatusBadge
 * 
 * Badge visual para mostrar el estado de una compra con color e ícono correspondiente
 * 
 * Estados soportados:
 * - completed: Completada (verde)
 * - pending: Pendiente (amarillo/naranja)
 * - failed: Fallida (rojo)
 * - refunded: Reembolsada (azul)
 * 
 * @param {string} status - Estado de la compra (completed|pending|failed|refunded)
 * @param {string} size - Tamaño del badge (small|medium|large)
 * @param {boolean} showIcon - Si mostrar el ícono (default: true)
 */

import React from 'react';
import PropTypes from 'prop-types';
import MDBadge from 'components/MDBadge';
import MDBox from 'components/MDBox';
import Icon from '@mui/material/Icon';
import { getStatusConfig } from 'services/purchaseService';

function PurchaseStatusBadge({ status, size = 'medium', showIcon = true }) {
  const config = getStatusConfig(status);

  // Mapeo de tamaños
  const sizeMap = {
    small: 'xs',
    medium: 'sm',
    large: 'md',
  };

  return (
    <MDBox display="flex" alignItems="center" gap={1}>
      {showIcon && (
        <Icon fontSize={size} color={config.color}>
          {config.icon}
        </Icon>
      )}
      <MDBadge
        badgeContent={config.label}
        color={config.color}
        variant={config.variant}
        size={sizeMap[size]}
      />
    </MDBox>
  );
}

PurchaseStatusBadge.propTypes = {
  status: PropTypes.oneOf(['completed', 'pending', 'failed', 'refunded']).isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  showIcon: PropTypes.bool,
};

PurchaseStatusBadge.defaultProps = {
  size: 'medium',
  showIcon: true,
};

export default PurchaseStatusBadge;
